import React, { Component } from 'react';
import Modal from '../../widgets/Modal';
import _ from 'lodash';
import {connect} from 'react-redux';

import Problem from './ListComponent/Problem';
import Goal from './ListComponent/Goal';
import Arrange from './ListComponent/Arrange';
import Education from './ListComponent/Education';
import Monitor from './ListComponent/Monitor';

import { fetchDiseaseLibs, fetchDiseaseLib, editDiseaseLib, newDiseaseLib, deleteDiseaseLib} from '../../../actions';
import { fetchArrangeLibs, fetchArrangeLib, editArrangeLib, newArrangeLib, deleteArrangeLib} from '../../../actions';
import { fetchGoalLibs, fetchGoalLib, editGoalLib, newGoalLib, deleteGoalLib} from '../../../actions';
import { fetchEducationLibs, fetchEducationLib, editEducationLib, newEducationLib, deleteEducationLib} from '../../../actions';
import { fetchMonitorLibs, fetchMonitorLib, editMonitorLib, newMonitorLib, deleteMonitorLib} from '../../../actions';
import { newProblem, newGoal, newArrange, newEducation, newMonitor } from '../../../actions';
class List extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showModal: false,
            tagDisease : "panelListed",
            searchDisease:'',
            diseaseDisplayed: this.props.diseaselibs,
            arrangeDisplayed : this.props.arrangelibs,
            goalDisplayed : this.props.goallibs,
            educationDisplayed : this.props.educationlibs,
            monitorDisplayed : this.props.monitorlibs,
            diseaseListed : [],
            goalListed:[],
            arrangeListed:[],
            educationListed:[],
            monitorListed:[]
        };

        this.onInputChange = this.onInputChange.bind(this);
        this.selectDisease = this.selectDisease.bind(this);
        this.onCreateList = this.onCreateList.bind(this);
    };


    //Initial Rendering
    componentDidMount() {
        
        this.props.fetchDiseaseLibs();
        this.props.fetchArrangeLibs();
        this.props.fetchGoalLibs();
        this.props.fetchEducationLibs();
        this.props.fetchMonitorLibs();
        this.setState({diseaseListed: [], goalListed:[], arrangeListed:[], educationListed:[], monitorListed:[]})
    }

    render() {
        return (
            <div  style={{ gridColumn : "span 4"}}>   
                <button onClick={() => this.setState({showModal: true})} className='btnew'>Add</button>
                {this.renderLibrary()}
            </div>
        )
    }

    //function upon disease double click, to add into list of disease, goal, todo, education, monitor
    
    selectDisease(event) {
        const togglePanel = event.currentTarget.className;
        if (togglePanel === "panelListed") {
            event.currentTarget.className="panelSelected";
            var disease = event.currentTarget.dataset.disease;

            // adding arrange list upon adding disease
            var arrangelib = this.props.arrangelibs;
            var k;
            var addarrangelist = [];
            for (k=0; k < arrangelib.length; k++) {
                var i;
                
                for (i=0; i < arrangelib[k].meta.length; i++) {
                    if (arrangelib[k].meta[i].disease.toLowerCase() === disease.toLowerCase()) {
                        var arrangelist = this.state.arrangeListed;
                        if (!arrangelist.includes(arrangelib[k].arrange)) {
                            addarrangelist.push(arrangelib[k].arrange);
                        }
                    }
                }
            }

            // adding goal list upon adding disease
            var goallib = this.props.goallibs;
            var g;
            var addgoallist = [];
            for (g=0; g< goallib.length; g++) {
                var t;
                for (t=0; t< goallib[g].meta.length; t++) {
                    if (goallib[g].meta[t].disease.toLowerCase() === disease.toLowerCase()) {
                        var goallist = this.state.goalListed;
                        if (!goallist.includes(goallib[g].item)) {
                            addgoallist.push(goallib[g].item);
                        }
                    }
                }
            }
            // adding education list upon adding disease
            var educationlib = this.props.educationlibs;
            var e;
            var addeducationlist = [];
            for (e=0; e< educationlib.length; e++) {
                
                for (t=0; t< educationlib[e].meta.length; t++) {
                    if (educationlib[e].meta[t].disease.toLowerCase() === disease.toLowerCase()) {
                        var educationlist = this.state.educationListed;
                        if (!educationlist.includes(educationlib[e].title)) {
                            addeducationlist.push(educationlib[e].title);
                        }
                    }
                }
            }
            // adding monitor list upon adding disease
            var monitorlib = this.props.monitorlibs;
            var m;
            var addmonitorlist = [];
            for (m=0; m< monitorlib.length; m++) {
                
                for (t=0; t< monitorlib[m].meta.length; t++) {
                    if (monitorlib[m].meta[t].disease.toLowerCase() === disease.toLowerCase()) {
                        var monitorlist = this.state.monitorListed;
                        if (!monitorlist.includes(monitorlib[m].panel)) {
                            addmonitorlist.push(monitorlib[m].panel);
                        }
                    }
                }
            }
            this.setState({
                diseaseListed: this.state.diseaseListed.concat(disease),
                arrangeListed: this.state.arrangeListed.concat(addarrangelist),
                goalListed: this.state.goalListed.concat(addgoallist),
                educationListed: this.state.educationListed.concat(addeducationlist),
                monitorListed: this.state.monitorListed.concat(addmonitorlist)
            })

        }
        else {

            // Redoing all list of arrange, goal, education, monitor when toggle off the disease from panel
            // go through current disease list
            // if current disease list is not equal to the deselected panel -> add it to the new disease list
            event.currentTarget.className="panelListed";

            var diseaseInput = event.currentTarget.dataset.disease;
            var currentDiseaseList = this.state.diseaseListed;
            var newDiseaseList = [];
            currentDiseaseList.map(item => {
                if (item !== diseaseInput) {
                    newDiseaseList.push(item);
                }
                return null;
            })

            //redo arrangelist
            // go through the new disease list after toggle off the disease panel from the library
            // for each disease go through arrange lib
            // if arrange library meta data disease is equal to the disease listed in the new disease
            // check if the new arrange list already contain it. If it doesn't add it to the new arrange list
            var newArrangeList = [];
            newDiseaseList.map(disease => {
                var arrangelib = this.props.arrangelibs;
                var k;
                for (k=0; k < arrangelib.length; k++) {
                    var i;
                    
                    for (i=0; i < arrangelib[k].meta.length; i++) {
                        if (arrangelib[k].meta[i].disease.toLowerCase() === disease.toLowerCase()) {
                            // checking for double entry
                            if (!newArrangeList.includes(arrangelib[k].arrange)) {
                                newArrangeList.push(arrangelib[k].arrange);
                            }
                        }
                    }
                }
                return null;
            });

            // redo goallist 
            var newGoalList = [];
            newDiseaseList.map(disease => {
                var goallib = this.props.goallibs;
                var k;
                for (k=0; k < goallib.length; k++) {
                    var i;
                    
                    for (i=0; i < goallib[k].meta.length; i++) {
                        if (goallib[k].meta[i].disease.toLowerCase() === disease.toLowerCase()) {
                            // checking for double entry
                            if (!newGoalList.includes(goallib[k].item)) {
                                newGoalList.push(goallib[k].item);
                            }
                        }
                    }
                }
                return null;
            });

            // redo education list 
            var newEducationList = [];
            newDiseaseList.map(disease => {
                var educationlib = this.props.educationlibs;
                var k;
                for (k=0; k < educationlib.length; k++) {
                    var i;
                    for (i=0; i < educationlib[k].meta.length; i++) {
                        if (educationlib[k].meta[i].disease.toLowerCase() === disease.toLowerCase()) {
                            // checking for double entry
                            if (!newEducationList.includes(educationlib[k].title)) {
                                newEducationList.push(educationlib[k].title);
                            }
                        }
                    }
                }
                return null;
            });

            // redo monitor list 
            var newMonitorList = [];
            
            newDiseaseList.map(disease => {
                var monitorlib = this.props.monitorlibs;
                var k;
                for (k=0; k < monitorlib.length; k++) {
                    var i;
                    for (i=0; i < monitorlib[k].meta.length; i++) {
                        if (monitorlib[k].meta[i].disease.toLowerCase() === disease.toLowerCase()) {
                            // checking for double entry
                            if (!newMonitorList.includes(monitorlib[k].panel)) {
                                newMonitorList.push(monitorlib[k].panel);
                            }
                        }
                    }
                }
                return null;
            });
                      
                        
            
            this.setState({diseaseListed:newDiseaseList, arrangeListed:newArrangeList, goalListed: newGoalList, educationListed: newEducationList, monitorListed: newMonitorList})
        }
    }

    // rendering available disease library - ERROR
    renderLibraryContent() {
        var diseaseSelected = this.state.diseaseListed;
        var toggleState;

        return this.state.diseaseDisplayed.map(disease =>  {
         
            toggleState = "panelListed";
            if (diseaseSelected.includes(disease) === true) {
                toggleState = "panelSelected";
            } 
      
            return (
                <div onDoubleClick={this.selectDisease} data-disease={disease.disease} className={toggleState}><b style={{fontSize:'14px'}}>{disease.disease}</b><br />
                {disease.category}, {disease.subcategory}<br />
                </div>
            )
        });
    }

    //change when keyword typed in the input box -> run filter function of the disease list
    onInputChange(event) {
        let newDiseaseList = _.filter(this.props.diseaselibs, disease => disease.disease.toLowerCase().includes(event.target.value.toLowerCase()) || disease.tags.toLowerCase().includes(event.target.value.toLowerCase()));
        this.setState({
            searchDisease : event.target.value,
            diseaseDisplayed : newDiseaseList
        })
    }

    //Render list of disease upon selection
    renderDiseaseList() {
        const list = this.state.diseaseListed;
        return list.map(item => {
            return (
                <div className='btTag' disabled style={{height:'20px'}}>{item}</div>
            )
        })     
    }

    //Render Goal List upon selection
    renderGoalList() {
        const list = this.state.goalListed;
        return list.map(item => {

            return (
                <div className='btTag' disabled style={{height:'20px'}}>{item}</div>
            )
        })     
    }

    //Render Arrange List upon selection
    renderArrangeList() {
        const list = this.state.arrangeListed;
        return list.map(item => {
            return (
                <div className='btTag' disabled style={{height:'20px'}}>{item}</div>
            )
        })     
    }

    //Render Education List upon selection
    renderEducationList() {
        const list = this.state.educationListed;
        return list.map(item => {

            return (
                <div className='btTag' disabled style={{height:'20px'}}>{item}</div>
            )
        })     
    }

    //Render Monitor List upon selection
    renderMonitorList() {
        const list = this.state.monitorListed;
        return list.map(item => {
            return (
                <div className='btTag' disabled style={{height:'20px'}}>{item}</div>
            )
        })     
    }

    // Render current Todo
    renderCurrentTodo() {
        const list = this.props.todos;
        return list.map(item => {
            return (
                <div className='btTag' disabled style={{height:'20px'}}>{item}</div>
            )
        })     
    }

    // Render current Goal
    renderCurrentGoal() {
        const list = this.props.goals;
        return list.map(item => {
            return (
                <div className='btTag' disabled style={{height:'20px'}}>{item}</div>
            )
        })     
    }

    // Render current Monitor
    renderCurrentMonitor() {
        const list = this.props.monitors;
        return list.map(item => {
            return (
                <div className='btTag' disabled style={{height:'20px'}}>{item}</div>
            )
        })     
    }
    
    // Render current Education
    renderCurrentEducation() {
        const list = this.props.educations;
        return list.map(item => {
            return (
                <div className='btTag' disabled style={{height:'20px'}}>{item}</div>
            )
        })     
    }

    // Render Current Problem
    renderCurrentProblem() {
        const list = this.props.problems;
        return list.map(item => {
            return (
                <div className='btTag' disabled style={{height:'20px'}}>{item}</div>
            )
        })     
    }
/////////////////////////////////////////////////

//Function upon clicking create button
//Creating patient's Problem, Goal, Arrange, Education and MOnitor LIst
    onCreateList() {
        var i;
        var b;
        var c;
        var existedProblem = [];
        var existedGoal = [];
        var existedArrange = [];
        var existedEducation = [];
        var existedMonitor = [];
        var t;
        for (t=0; t< this.props.problems.length; t++) {
            existedProblem.push(this.props.problems[t].problem);
        }

        for (t=0; t< this.props.arranges.length; t++) {
            existedArrange.push(this.props.arranges[t].arrange);
        }

        for (t=0; t< this.props.goals.length; t++) {
            existedGoal.push(this.props.goals[t].item);
        }

        for (t=0; t< this.props.educations.length; t++) {
            existedEducation.push(this.props.educations[t].title);
        }
        for (t=0; t< this.props.monitors.length; t++) {
            existedMonitor.push(this.props.monitors[t].panel);
        }

            
        // Adding Disease in Problem if it doesn't exist already
        for (i=0; i<this.state.diseaseListed.length; i++) {
            if (existedProblem.includes(this.state.diseaseListed[i]) === false) {
                console.log(this.state.diseaseListed[i] + " not existed");
                var problem = {
                    "notes":"currently stable",
                    "priority":"",
                    "status":"",
                    "privacy":"false",
                    "meta":[{
                        "practiceID": "Howlong",
                        "externalID" : "234",
                        "provider":"Dr Findacure"
                    }]}
                
                problem['patientId'] = this.props.patient._id;
                problem['problem'] = this.state.diseaseListed[i];
                this.props.newProblem(problem);
            }    
            else {
                console.log(this.state.diseaseListed[i] + " existed already");
            }
        }
        
        //Adding arrange in patient arrange list if it doesn't exist already
        for (b=0; b<this.state.arrangeListed.length; b++) {
            if (existedArrange.includes(this.state.arrangeListed[b]) === false) {
                console.log(this.state.arrangeListed[b] + " doesn't exist");
                var arrange = {
                    "status":"",
                    "privacy": "false",
                    "tag" : "",
                    "meta" : [{
                        "practiceID": "Howlong",
                        "externalID" : "234",
                        "provider":"Dr Findacure"
                    }]}
                    arrange['patientId'] = this.props.patient._id;
                    arrange['arrange'] = this.state.arrangeListed[b];
                    this.props.newArrange(arrange);
                
            } else {
                console.log(this.state.arrangeListed[b] + " exis already")
            }

        }

        // adding goal into patient care plan
        for (c=0; c<this.state.goalListed.length; c++) {
            if (existedGoal.includes(this.state.goalListed[c]) === false) {
                console.log(this.state.goalListed[c] + " doesn't exist");

                let selectedGoalLibrary = _.find(this.props.goallibs, { 'item': this.state.goalListed[c] });
                var goal = {
                "status":"",
                "privacy": "false",
                "tag" : "",
                "meta" : [{
                    "practiceID": "Howlong",
                    "externalID" : "234",
                    "provider":"Dr Findacure"
                }]}
                goal['patientId'] = this.props.patient._id;
                goal['item'] = this.state.goalListed[c];
                goal['type'] = selectedGoalLibrary.type;
                goal['panel'] = selectedGoalLibrary.panel;
                goal['operator'] = selectedGoalLibrary.operator;
                goal['target'] = selectedGoalLibrary.target;
                this.props.newGoal(goal);

            } else {
                console.log(this.state.goalListed[c] + " exist already");
            }
        }

        //adding education into patient care plan
        for (c=0; c<this.state.educationListed.length; c++) {
            if (existedEducation.includes(this.state.educationListed[c]) === false) {
                console.log(this.state.educationListed[c] + " doesn't exist");
    
                let selectedEducationLibrary = _.find(this.props.educationlibs, { 'title': this.state.educationListed[c] });
        
                var education = {
                "status":"Assigned",
                "privacy": "false",
                "meta" : [{
                    "practiceID": "Howlong",
                    "externalID" : "234",
                    "provider":"Dr Findacure"
                }]}
                education['patientId'] = this.props.patient._id;
                education['title'] = selectedEducationLibrary.title;  
                education['link'] = selectedEducationLibrary.link;
                var tag =[];     
                for (i=0; i< selectedEducationLibrary.meta.length; i++ ) {
                    var problemID = selectedEducationLibrary.meta[i].diseaseID;
                    problem = selectedEducationLibrary.meta[i].disease;
                    tag.push({problemID, problem});
                }
                education['tag'] = tag;

                console.log(education);
                this.props.newEducation(education);

            } else {
                console.log(this.state.educationListed[c] + " exist already");
            }
        }

        //adding monitor into patient care plan
        for (c=0; c<this.state.monitorListed.length; c++) {
            if (existedMonitor.includes(this.state.monitorListed[c]) === false) {
                console.log(this.state.monitorListed[c] + " doesn't exist");
                let selectedMonitorLibrary = _.find(this.props.monitorlibs, { 'panel': this.state.monitorListed[c] });
               
                var monitor = {};
                monitor['patientId'] = this.props.patient._id;
                monitor['type'] = selectedMonitorLibrary.type; 
                monitor['panel'] = selectedMonitorLibrary.panel;
                monitor['frequency'] = "every 6 months";

                var meta =[];     
                for (i=0; i< selectedMonitorLibrary.meta.length; i++ ) {
                    var diseaseID = selectedMonitorLibrary.meta[i].diseaseID;
                    var disease = selectedMonitorLibrary.meta[i].disease;
                    meta.push({diseaseID, disease});
                }
                monitor['meta'] = meta;

                var flag =[];     
                for (i=0; i< selectedMonitorLibrary.flag.length; i++ ) {
                    var test = selectedMonitorLibrary.flag[i].test;
                    var minmax = selectedMonitorLibrary.flag[i].minmax;
                    var value = selectedMonitorLibrary.flag[i].value;
                    flag.push({test, minmax, value});
                }
                monitor['flag'] = flag;

                console.log(monitor);
                this.props.newMonitor(monitor);

            } else {
                console.log(this.state.monitorListed[c] + " exist already");
            }
        }
        
    }

    renderLibrary() {
        const showLibrary = () => {
            return (
                <div style={{display:'grid', gap :'10px', gridTemplateColumns:' 270px 240px 240px 240px 240px 240px', gridTemplateRows:'320px 300px'}}>
                    <div style={{gridRow:'span 3'}}>
                        <input type='text' onChange={this.onInputChange} placeholder='type in disease/problem ...' />
                        <p></p>
                        <div style={{ height:'540px', overflowY : 'scroll'}}> 
                        {this.renderLibraryContent()}
                        </div>
                    </div>
                    <div>
                        Problem to be managed
                        <p></p>
                        <div style={{ height:'280px', overflowY : 'scroll'}}>
                        {this.renderDiseaseList()}
                        </div>
                      
                    </div>
                    <div>
                        Goals
                        <p></p>
                        <div style={{ height:'280px', overflowY : 'scroll'}}>
                        {this.renderGoalList()}
                        </div>
                    </div>
                    <div>
                        Arrange
                        <p></p>
                        <div style={{ height:'280px', overflowY : 'scroll'}}>
                        {this.renderArrangeList()}
                        </div>
                    </div>  
                    <div>
                        Education
                        <p></p>
                        <div style={{ height:'280px', overflowY : 'scroll'}}>
                        {this.renderEducationList()}
                        </div>
                    </div> 
                    <div>
                        Monitor
                        <p></p>
                        <div style={{ height:'280px', overflowY : 'scroll'}}>
                        {this.renderMonitorList()}
                        </div>
                    </div>  
                    <div style={{ height:'280px', overflowY : 'scroll'}}>
                        Existing problems<p></p>
                        <Problem />
                    </div>
                    <div style={{ height:'280px', overflowY : 'scroll'}}>
                        Existing Goals<p></p>
                        <Goal />
                    </div>
                    <div style={{ height:'280px', overflowY : 'scroll'}}>
                        Existing Arrange<p></p>
                        <Arrange />
                    </div>
                    <div style={{ height:'280px', overflowY : 'scroll'}}>
                        Existing Education<p></p>
                        <Education />
                    </div>
                    <div style={{ height:'280px', overflowY : 'scroll'}}>
                        Existing Monitoring<p></p>
                        <Monitor />
                    </div>
                    <div  style={{gridColumn:'span 6'}}>
                        <button style={{float:'right', width:'100px'}} onClick={this.onCreateList} className="btnew">Create</button>
                    </div>
                </div>
            )
        }

        return (
            <Modal 
                height='700px'
                width='1600px'
                open={this.state.showModal} 
                title='Chronic Disease Library'
                data =""
                content = {showLibrary()}             
                onDismiss={() => this.setState({showModal: false, diseaseListed : [],goalListed:[], arrangeListed:[], educationListed:[], monitorListed:[] })}
            />
        )
    }
}

const mapStateToProps = (state) => {
    return { 
        patient : state.selectedPatient,
        diseaselibs : Object.values(state.diseaselibs),
        selectedDiseaseLib : state.selectedDiseaseLib,
        arrangelibs : Object.values(state.arrangelibs),
        goallibs : Object.values(state.goallibs),
        educationlibs : Object.values(state.educationlibs),
        monitorlibs : Object.values(state.monitorlibs),
        problems : Object.values(state.problems),
        arranges : Object.values(state.arranges),
        goals : Object.values(state.goals),
        educations : Object.values(state.educations),
        monitors : Object.values(state.monitors),
        userId : state.auth.userId
    }
}

export default connect(mapStateToProps, {
    fetchDiseaseLibs, fetchDiseaseLib, editDiseaseLib, newDiseaseLib, deleteDiseaseLib, 
    fetchArrangeLibs, fetchArrangeLib, editArrangeLib, newArrangeLib, deleteArrangeLib,
    fetchGoalLibs, fetchGoalLib, editGoalLib, newGoalLib, deleteGoalLib,
    fetchEducationLibs, fetchEducationLib, editEducationLib, newEducationLib, deleteEducationLib,
    fetchMonitorLibs, fetchMonitorLib, editMonitorLib, newMonitorLib, deleteMonitorLib,
    newProblem, newGoal, newArrange, newEducation, newMonitor
    })(List);



